import pageheader from "../../pageheader";
import alertConfiguration from "../AddAlertConfiguration/Configuration/index.vue";
import notificationPreferences from "../AddAlertConfiguration/NotificationPreferences/index.vue";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";

export default {
  name: "alert-configuration-read",
  components: { alertConfiguration, notificationPreferences, pageheader },
  data() {
    return {
      items: ["Alert Configuration", "Alert Notification Preferences"],
      tab: "",
      tabchange: false,
      dataToPreference: {},
      dataToPreferenceWithObject: {},
      permissionObj: {},
      input: {},
    };
  },

  computed: {
    ...mapGetters(["roles"]),
  },

  mounted() {
    this.input = utils.getInputContent("alertconfiguration", this.roles);
  },
  methods: {
    tabchangefun() {
      this.tabchange = true;
    },
    handleNextClick(data) {
      this.tab = 1;
      this.dataToPreference = data;
    },
    handleNextClickWithObject(data) {
      this.dataToPreferenceWithObject = data;
    },
    navigateToAlertsList() {
      this.$router.push({ path: "/alert-configuration/list" });
    },
  },
};
